import React from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import AddCampaignLayer from '../components/campaigns/AddCampaignLayer'

export const AddCampaignPage = () => {
  return (
    <MasterLayout>
        <AddCampaignLayer/>
    </MasterLayout>
  )
}
